"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Revive = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var clone_deep_1 = __importDefault(require("clone-deep"));
var produce = function (input, mutator) {
    var output = (0, clone_deep_1.default)(input, function (x) {
        if (x instanceof Map)
            return new Map(x);
        if (x instanceof Set)
            return new Set(x);
        return (0, clone_deep_1.default)(x);
    });
    return mutator(output) || output;
};
exports.Revive = { produce: produce };
